<template>
  <div class="dealer-tools">
    <div class="header">
      <div class="title">Dealer Tools</div>
      <div class="description">Designed and developed for integrators by an integrator</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          You are currently a dealer member of {{myDealerName}}.
          <!-- Guardian Alarm Systems<br>
          5870 Greenwood Rd, Shreveport, LA 71119 USA<br>
          +1 (318)688-4698<br>
          customercare@simplyguardian.com -->
        </div>
      </div>
    </div>
    <div class="apps">
      <!-- dealer portal -->
      <div
      v-if="!ipAuthIP"
      class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'dealer'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <template v-if="myDealerType === 'Wholesale Monitoring Station'">
          <div class="title">WCS Dealer Portal</div>
          <div class="description">WCS Dealer Portal to manage all your sub dealers and to manage all your CHeKT devices.</div>
          <div class="action-btns">
            <div
            v-on:click="goToURL($env.wcsWebUrl)" ontouchstart=""
            class="action-btn">Open Dealer Portal</div>
          </div>
        </template>
        <template v-else>
          <div class="title">Dealer Portal</div>
          <div class="description">Dealer Portal to manage all your CHeKT devices.</div>
          <div class="action-btns">
            <div
            v-on:click="goToURL($env.dealerWebUrl)" ontouchstart=""
            class="action-btn">{{$env.dealerWebUrl}}</div>
          </div>
        </template>
      </div>
      <!-- monitoring -->
      <!-- <div class="app">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'monitoring'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Monitoring Portal</div>
        <div class="description">Monitoring Portal to view events in real time.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL($env.monitoringWebUrl)" ontouchstart=""
          class="action-btn">{{$env.monitoringWebUrl}}</div>
        </div>
      </div> -->
      <!-- dealer mobile -->
      <div
      v-if="!ipAuthIP"
      class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'dealerMobile'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Dealer Mobile App</div>
        <div class="description">Dealer Mobile App for CHeKT device installation and maintenance.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL('https://itunes.apple.com/us/app/chekt-dealer/id1196085905')" ontouchstart=""
          class="action-btn">iOS</div>
          &nbsp;&nbsp;
          <div
          v-on:click="goToURL('https://play.google.com/store/apps/details?id=com.ionicframework.mdealer590736')" ontouchstart=""
          class="action-btn">Android</div>
        </div>
      </div>
      <!-- status -->
      <!-- Disabled for now, will be displayed again once status page is completely integrated in our service operation process. -->
      <!-- <div class="app">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'status'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">CHeKT Service Status</div>
        <div class="description">CHeKT Service Status to check service operation status in real time.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL('http://status.chekt.com')" ontouchstart=""
          class="action-btn">http://status.chekt.com</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import CompAppIcon from '@/components/CompAppIcon'
export default {
  name: 'dealer-tools',
  components: {
    CompAppIcon
  },
  computed: {
    myDealerName: function () {
      return this.$store.getters.myDealerName
    },
    myDealerType: function () {
      return this.$store.getters.myDealerType
    },
    ipAuthIP: function (state) {
      return this.$store.getters.idTokenIPAuthIP
    }
  },
  data: function () {
    return {
      appIconWidth: 340
    }
  },
  methods: {
    goToURL: function (url) {
      this.$tool.openNewTab(url)
    }
  }
}
</script>

<style scoped>

.dealer-tools {
  /* size */
  width: 100%;
  height: 100%;
}

.dealer-tools .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* alignment */
  text-align: left;
}
.dealer-tools .header .title {
  /* common */
  font-size: 3em;
  font-weight: bold;
}
.dealer-tools .header .description {
  /* common */
  font-size: 1.5em;
}

.dealer-tools .apps {
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.dealer-tools .app {
  /* common */
  font-size: 16px;
  /* size */
  max-width: 340px;
  width: 100%;
  /* position */
  margin-right: 2em;
  margin-bottom: 1em;
  /* alignment */
  text-align: left;
}
.dealer-tools .app .title {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 16px;
  /* text */
  font-weight: bold;
  line-height: 2rem;
  /* position */
  margin-top: 1.5rem;
  margin-bottom: 10px;
}
.dealer-tools .app .description {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 14px;
  /* text */
  color: var(--gray-medium);
  /* position */
  margin-bottom: 10px;
}
.dealer-tools .app .icon-container {
  /* common */
  overflow: hidden;
  border-radius: 4px;
}
.dealer-tools .app .action-btns {
  /* common */
  font-size: 14px;
  /* size */
  padding-right: 0.5em;
  /* position */
  margin-bottom: 10px;
  /* alignment */
  display: flex;
  flex-direction: row;
}
.dealer-tools .app .action-btns .action-btn {
  /* common */
  color: var(--gray-low);
  /* mouse */
  cursor: pointer;
}
.dealer-tools .app .action-btns .action-btn:hover {
  /* common */
  color: var(--primary);
}

.dealer-tools .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid #dedede;
  /* alignment */
  text-align: left;
}

.dealer-tools .body .content {
  /* common */
  color: var(--gray-medium);
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: 100%;
  /* min-height: 4em; */
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}

.dealer-tools .body .content .info-container:first-child {
  margin-top: 0;
}
.dealer-tools .body .content .info-container {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  margin: 1em 0;
  /* alignment */
  display: table;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/DealerTools.vue